import {
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
// import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import { t } from "i18next";
import {
  formattaDataCompatta,
  formatTimeRange,
} from "../../../utils/functions/date-utils";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import { useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import {
  useDeleteBookingMutation,
  useGetBookingsQuery,
} from "../../api/user/gestisciPraticheApi";

const BookingTable = ({ onClose }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [idBook, setIdBook] = useState();
  const userCF = useSelector((state) => state.app.profile.fiscalCode);

  const { data: getBooking, isLoading } = useGetBookingsQuery(userCF, {
    skip: !userCF,
  });

  const [deleteBooking] = useDeleteBookingMutation();

  const handleCloseDelete = () => setOpenDialog(false);

  const handleConfermDialog = () => {
    deleteBooking(idBook).then((res) => {
      console.log(res);
      if (res.data.Result !== 1) {
        toast.error(res.data.Exception || t("NotDeleteBooking"));
        return;
      }
      toast.success(t("DeleteBooking"));
      onClose();
      handleCloseDelete();
    });
  };

  const handleOpenDialog = (id) => {
    setOpenDialog(true);
    setIdBook(id);
  };

  if (isLoading) {
    return <CoreSpinner />;
  }

  return (
    <div>
      <h3 className="py-2 text-center">{t("Reservations")}</h3>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: "silver" }}>
              <TableCell>{t("Date")}</TableCell>
              <TableCell>{t("Ora")}</TableCell>
              <TableCell>{t("City")}</TableCell>
              <TableCell>{t("Sede")}</TableCell>
              {/* <TableCell>{t("Sportello")}</TableCell> */}
              <TableCell>{t("Actions")}</TableCell>
            </TableRow>
          </TableHead>
          {getBooking?.Data?.map((book) => (
            <TableRow className="hover:shadow-md" key={book.id}>
              <TableCell>{formattaDataCompatta(book.data)}</TableCell>
              <TableCell>
                {formatTimeRange(book.ora_Inizio, book.ora_Fine)}
              </TableCell>
              <TableCell>{book.descrizione_Provincia}</TableCell>
              <TableCell>{book.descrizione_Sede}</TableCell>
              {/* <TableCell>{book.descrizione_Sportello}</TableCell> */}
              <TableCell>
                {/* <Tooltip title={t("Edit")}>
                  <IconButton
                    onClick={() => console.log(book)}
                    className="w-10 h-10"
                  >
                    <EditRoundedIcon />
                  </IconButton>
                </Tooltip> */}
                <Tooltip title={t("Delete")}>
                  <IconButton
                    onClick={() => handleOpenDialog(book.id)}
                    className="w-10 h-10"
                  >
                    <DeleteIcon className="text-red-600" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
          {getBooking?.Data?.length === 0 && (
            <TableRow>
              <TableCell colSpan={6} className="text-center text-gray">
                {t("NoBooking")}
              </TableCell>
            </TableRow>
          )}
        </Table>
      </TableContainer>
      <CoreDialog
        open={openDialog}
        title={`Elimina Prenotazione`}
        content={`Sei sicuro di eliminare la prenotazione?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfermDialog}
        closeDialog={handleCloseDelete}
      />
    </div>
  );
};

export default BookingTable;
